/* import __COLOCATED_TEMPLATE__ from './connect.hbs'; */
/* RESPONSIBLE TEAM: team-standalone */

import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import type SalesforceConfiguration from 'embercom/models/standalone/salesforce-configuration';
import type FinStandaloneService from 'embercom/services/fin-standalone-service';
import { type PulseAccordion } from 'glint/pulse';
import { action } from '@ember/object';
import type IntlService from 'embercom/services/intl';
import type { ConnectionOption } from 'embercom/components/standalone/common/connect-card';
import { tracked } from '@glimmer/tracking';

interface Args {
  accordion: PulseAccordion;
  onContinue: () => void;
}

export default class Connect extends Component<Args> {
  @service declare appService: any;
  @service declare finStandaloneService: FinStandaloneService;
  @service declare intl: IntlService;

  @tracked showManageConnection = false;

  get salesforceConfig(): SalesforceConfiguration {
    return this.finStandaloneService.salesforceConfig!;
  }

  get isComplete() {
    return this.salesforceConfig.isConnected;
  }

  get salesforceConnectionCard(): ConnectionOption {
    return {
      value: 'salesforce',
      icon: 'salesforce',
      label: this.intl.t(
        'standalone.salesforce.setup.article-sync.step-wrapper.steps.connect.label',
      ),
      description: this.intl.t(
        'standalone.salesforce.setup.article-sync.steps.connect.description',
      ),
      isConnected: this.salesforceConfig?.isConnected,
      stampConnected: this.intl.t(
        'standalone.salesforce.setup.article-sync.steps.connect.stamp-connected',
        {
          instanceUrl: this.salesforceConfig.instanceUrl,
        },
      ),
      manage: () => {
        this.toggleManageConnection();
      },
      connect: () => {
        this.toggleManageConnection();
      },
    };
  }

  @action toggleManageConnection() {
    this.showManageConnection = !this.showManageConnection;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Standalone::Deploy::Salesforce::Cases::Integrate::Connect': typeof Connect;
    'standalone/deploy/salesforce/cases/integrate/connect': typeof Connect;
  }
}
